import { render } from "./SettingsMenuChatIdComp.vue?vue&type=template&id=2d68e135&scoped=true"
import script from "./SettingsMenuChatIdComp.vue?vue&type=script&lang=js"
export * from "./SettingsMenuChatIdComp.vue?vue&type=script&lang=js"

import "./SettingsMenuChatIdComp.vue?vue&type=style&index=0&id=2d68e135&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d68e135"]])

export default __exports__